import { render, staticRenderFns } from "./HazardousGood26.vue?vue&type=template&id=176f7f3f&scoped=true"
import script from "./HazardousGood26.vue?vue&type=script&lang=js"
export * from "./HazardousGood26.vue?vue&type=script&lang=js"
import style0 from "./HazardousGood26.vue?vue&type=style&index=0&id=176f7f3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176f7f3f",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fhazardous-good-26%2FHazardousGood26.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports